// extracted by mini-css-extract-plugin
export default {"root":"tO96","name":"LrMm","id":"jOJB","id-prefix":"_lHw","idPrefix":"_lHw","divider":"uCDu","created-at-status":"R76p","createdAtStatus":"R76p","status":"vjnk"};